/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const tableAvailabilitySchema = z.object({
	id: z.uuid(),
	number: z.int(),
	name: z.string(),
	seating_capacity: z.int(),
	available_times: z.array(z.string()).describe("Время начала в формате ЧЧ:ММ — для показа гостю"),
	available_start_times: z
		.array(z.string())
		.describe(
			"То же время с датой, в том виде, в каком его принимает создание брони. У заведения, работающего за полночь, часть времени приходится на следующие сутки т.к. 00:30 в дне 24 сентября — это 25 сентября 00:30",
		),
});
